<template>
  <b-card v-if="isPermitted('request')">

    <div>
      <b-form
        inline
        class="mb-2"
      >

        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          class="d-inline-block mr-1 mb-1"
          @click="createNew"
        >
          {{ $t('Add') }}
        </b-button>

        <b-form-input
          v-model="searchTerm"
          :placeholder="$t('message.SearchPlaceholder')"
          type="text"
          class="d-inline mr-1 mb-1"
        />

        <v-select
          id="vue-select-request-status"
          v-model="requestStatus"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :options="optionRequestStatus"
          :clearable="false"
          :reduce="item => item.value"
          class="d-inline mb-1"
        />

      </b-form>

      <!-- table -->
      <vue-good-table
        style-class="vgt-table striped"
        :columns="columns"
        :rows="rows"
        :sort-options="{
          enabled: true,
          initialSortBy: { field: 'id', type: 'desc' }
        }"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm
        }"
        :select-options="{
          enabled: false,
          selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
          selectionInfoClass: 'custom-class',
          selectionText: 'rows selected',
          clearSelectionText: 'clear',
          disableSelectInfo: true, // disable the select info panel on top
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
          mode: 'records',
          perPage: 10,
          perPageDropdown: [10, 50, 100],
          dropdownAllowAll: false,
        }"
      >

        <template
          slot="table-column"
          slot-scope="props"
        >
          <span>
            {{ $t(props.column.label) }}
          </span>
        </template>

        <template
          slot="table-row"
          slot-scope="props"
        >

          <!-- Column: requestDate -->
          <span
            v-if="props.column.field === 'id'"
            class="text-nowrap"
          >
            <b-link
              v-if="isPermitted('requestEdit')"
              @click="close(props.row)"
            >
              <feather-icon icon="ThumbsUpIcon" />
            </b-link>

            <b-link
              v-if="isPermitted('requestEdit')"
              class="ml-1"
              @click="reject(props.row)"
            >
              <feather-icon icon="ThumbsDownIcon" />
            </b-link>

            <b-link
              v-if="isPermitted('requestDelete')"
              class="ml-1"
              @click="confirmDelete(props.row)"
            >
              <feather-icon icon="TrashIcon" />
            </b-link>
          </span>
          <span
            v-else-if="props.column.field === 'requestDate'"
            class="text-nowrap"
          >
            {{ formatDate(props.row.requestDate) }}
          </span>
          <!-- Column: closeDate -->
          <span
            v-else-if="props.column.field === 'closeDate' && props.row.closeDate"
            class="text-nowrap"
          >
            {{ formatDate(props.row.closeDate) }}
          </span>

          <!-- Column: Common -->
          <span v-else>
            {{ $t(props.formattedRow[props.column.field]) }}
          </span>
        </template>

      </vue-good-table>

      <modal-item
        item-type="request"
        :edit-item="edit_item"
        @submit="loadData"
        @clear="edit_item=null"
      />

    </div>
  </b-card>
</template>

<script>

import { getUserData, isPermitted } from '@/auth/utils'
import useJwt from '@/auth/jwt/useJwt'
import { VueGoodTable } from 'vue-good-table'
import {
  BCard, BForm, BFormInput, BButton, BLink,
} from 'bootstrap-vue'
import dayjs from 'dayjs'
import Ripple from 'vue-ripple-directive'
import ModalItem from '@/layouts/components/ModalItem.vue'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
    BCard,
    BForm,
    BFormInput,
    BButton,
    BLink,
    VueGoodTable,
    ModalItem,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      edit_item: null,
      requestStatus: 'All Requests',
      pageLength: 10,
      listColumns: [],
      rows: [],
      searchTerm: '',
      columns: [
        {
          label: '#',
          field: 'id',
          type: 'number',
          tdClass: 'text-center',
          thClass: 'text-center',
          width: '50px',
        },
        {
          label: 'Request Date',
          field: 'requestDate',
        },
        {
          label: 'Request By',
          field: 'requestBy',
        },
        {
          label: 'Category',
          field: 'requestCategory',
        },
        {
          label: 'Description',
          field: 'requestDetail',
        },
        {
          label: 'Estimated Duration',
          field: 'estimatedDuration',
        },
        {
          label: 'Status',
          field: 'status',
        },
        {
          label: 'Close Date',
          field: 'closeDate',
        },
        {
          label: 'Close Description',
          field: 'closeDescription',
        },
      ],
      optionRequestStatus: [
        { label: this.$t('All Requests'), value: 'All Requests' },
        { label: this.$t('In Progress'), value: 'In Progress' },
        { label: this.$t('Rejected'), value: 'Rejected' },
        { label: this.$t('Completed'), value: 'Completed' },
      ],
    }
  },
  watch: {
    requestStatus() {
      this.loadData()
    },
  },
  created() {
    this.loadData()
    this.userData = getUserData()
  },
  methods: {
    confirmDelete(item) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You are about to delete a request...',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          useJwt.axiosIns.delete(`request/${item.id}`)
            .then(response2 => {
              if (response2.data) {
                this.loadData()
              }
            })
            .catch(e => {
              console.log(e)
            })
        }
      })
    },
    close(item) {
      this.edit_item = JSON.parse(JSON.stringify(item))
      this.edit_item.status = 'Completed'
      this.$bvModal.show('add-item')
    },
    reject(item) {
      this.edit_item = JSON.parse(JSON.stringify(item))
      this.edit_item.status = 'Rejected'
      this.$bvModal.show('add-item')
    },
    createNew() {
      this.$bvModal.show('add-item')
    },
    isPermitted(code) {
      if (!this.userData) {
        return false
      }
      return isPermitted(this.userData.role, code, this.userData.userGroups)
    },
    formatDate(date) {
      return dayjs(date).format('DD.MM.YYYY HH:mm:ss')
    },
    async loadData() {
      this.edit_item = null
      this.$bvModal.hide('add-item')
      useJwt.axiosIns.get(`request/${this.requestStatus}`)
        .then(async response2 => {
          if (response2.data) {
            this.rows = response2.data
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
